import * as React from "react";
import { BlossomComponent } from "src/components/flexFramework/domain/BlossomComponent";
import { ExtendedTemplateComponent } from "src/stores/ExperienceTemplateStore/typings";

export const PackagesStandaloneWizardModulesContext = React.createContext<{
  templateComponents: ExtendedTemplateComponent[] | undefined;
  blossomComponent: BlossomComponent | undefined;
}>({ templateComponents: undefined, blossomComponent: undefined });
